import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=369f7ac4&scoped=true&"
import script from "./Sport.vue?vue&type=script&lang=js&"
export * from "./Sport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f7ac4",
  null
  
)

export default component.exports